/**
 * Arama kutuları için güvenli metin dönüşümü.
 *
 * Firestore alanları her zaman string değil: proje kodu ya da telefon numarası
 * sayı olarak kaydedilmiş olabilir, alan hiç yazılmamışsa undefined gelir.
 * Bu değerlerde doğrudan `.toLowerCase()` çağırmak
 * "x.toLowerCase is not a function" hatasıyla sayfayı düşürüyordu.
 *
 * Küçültme Türkçe yerel ayarıyla yapılır. Aramanın çalışması için hem aranan
 * terimin hem de içinde arandığı metnin AYNI fonksiyondan geçmesi şart:
 * 'I' harfi tr yerelinde 'ı'ya düşer, iki taraf farklı yerel kullanırsa
 * eşleşme kaybolur.
 */
export const toSearchText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).toLocaleLowerCase('tr');
};

/**
 * Verilen parçalardan herhangi biri terimi içeriyor mu?
 * Boş terim her zaman eşleşir.
 */
export const matchesSearchTerm = (term, ...parts) => {
  const needle = toSearchText(term).trim();
  if (!needle) return true;
  return parts.some((part) => toSearchText(part).includes(needle));
};
